/* eslint-disable */
import Vue from 'vue'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate/dist/vee-validate.full'
import {
  email,
  max,
  min,
  numeric,
  required,
  alpha_spaces,
} from 'vee-validate/dist/rules'

extend('email', {
  ...email,
  message: 'El campo debe tener un formato de email valido',
})
extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'Este campo solo acepta caracteres alfabeticos',
})
extend('required', {
  ...required,
  message: 'El campo no puede estar vacio',
})
extend('max', {
  ...max,
  message: 'El campo debe tener una longitud maxima de {length} caracteres',
})
extend('min', {
  ...min,
  message: 'El campo debe tener una longitud maxima de {length} caracteres',
})
extend('numeric', {
  ...numeric,
  message: 'El campo debe ser de tipo numerico',
})

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)
